export const SCOPES = [
  // to add album to library
  'user-library-modify',

  // to read profile
  'user-read-private',

  // required to get their email so we can notify them after adding and use it for AE
  'user-read-email',

  // to follow artists
  'user-follow-modify',

  // additional scopes required for AE
  'user-read-recently-played',
  'user-follow-read',
  'user-library-read',
  'user-top-read',
  'playlist-read-private',
];

export const LEGACY_SCOPES = [
  // to add album to library
  'user-library-modify',

  // to read profile
  'user-read-private',

  // required to get their email so we can notify them after adding
  'user-read-email',

  // to follow artists
  'user-follow-modify',
];
